export default "__VITE_ASSET__ba45224e__"